/** A data-quality grade as four pips and the letter (A best). The letter is always printed, so the
 * grade never rests on the colour ramp alone; the pips are a glance, `role="img"` carries the words.
 */

import styles from "./QualityMeter.module.css";

export type QualityGrade = "A" | "B" | "C" | "D";

const FILLED: Record<QualityGrade, number> = { A: 4, B: 3, C: 2, D: 1 };
const PIPS = [0, 1, 2, 3] as const;

export function QualityMeter({
  grade,
  showLetter = true,
  testId,
}: {
  grade: QualityGrade;
  /** Print the letter beside the pips. Turn off only where the column header already says "Grade". */
  showLetter?: boolean;
  testId?: string;
}) {
  const filled = FILLED[grade];
  return (
    <span className={styles.meter} data-grade={grade} data-testid={testId}>
      <span role="img" aria-label={`Data quality grade ${grade}`} className={styles.pips}>
        {PIPS.map((i) => (
          <span
            key={i}
            aria-hidden="true"
            className={`${styles.pip} ${i < filled ? styles.on : ""}`}
            style={i < filled ? { background: `var(--q-${grade.toLowerCase()})` } : undefined}
          />
        ))}
      </span>
      {showLetter ? (
        <span className={styles.letter} aria-hidden="true">
          {grade}
        </span>
      ) : null}
    </span>
  );
}
